export const faqs = [
  {
    question: '宅宅资源库的资源都是从哪里来的？',
    answer: '宅宅资源库的资源来源于互联网公开分享渠道，由社区热心用户整理提交。我们的编辑团队会对资源进行审核和分类，确保资源的质量和可用性。所有资源仅供学习和交流使用，请在下载后24小时内删除。',
  },
  {
    question: '如何下载宅宅资源库中的资源？',
    answer: '进入任意资源详情页，您会看到下载链接区域。我们提供多种下载方式，包括百度网盘、阿里云盘、OneDrive等。点击对应的下载按钮即可跳转到下载页面。部分资源可能需要回复或积分才能查看下载链接。',
  },
  {
    question: '下载的资源文件是什么格式？',
    answer: '动漫资源通常为MKV或MP4格式，包含中文字幕。漫画资源为JPG/PNG图片压缩包或PDF格式。游戏资源为标准安装包或免安装硬盘版。轻小说资源为EPUB、TXT或PDF格式。具体格式请查看每个资源的详情说明。',
  },
  {
    question: '为什么有些资源找不到？可以求资源吗？',
    answer: '我们的资源库正在持续扩充中，如果暂时没有您想要的资源，欢迎在社区求资源区发帖说明需求。我们的编辑和热心宅友们会尽力帮助寻找。同时，您也可以加入我们的QQ群/Telegram群与其他宅友交流。',
  },
  {
    question: '宅宅资源库需要付费吗？',
    answer: '宅宅资源库目前完全免费开放！所有资源均可免费查看和下载。我们通过社区广告和用户捐赠来维持运营。如果您喜欢宅宅资源库，欢迎通过捐赠支持我们，让我们能持续为大家提供更好的服务。',
  },
  {
    question: '下载的资源打不开或有问题怎么办？',
    answer: '如果遇到文件损坏、解压密码错误、字幕不同步等问题，请在对应资源的评论区反馈。我们的编辑会尽快核实并修复。如果是网盘链接失效，也请及时反馈，我们会尽快补链。',
  },
  {
    question: '如何在手机上访问宅宅资源库？',
    answer: '宅宅资源库采用响应式设计，在手机浏览器中直接访问我们的网址即可获得适配移动端的浏览体验。我们也在开发官方App，敬请期待！此外，您还可以关注我们的微信公众号获取最新资源推送。',
  },
  {
    question: '宅宅资源库的更新频率如何？',
    answer: '我们的编辑团队每天都会更新资源！新番通常在播出后24小时内更新中文字幕版本，热门漫画和轻小说也会在汉化组发布后第一时间收录。您可以在首页的"今日更新"区域查看最新上线的资源。',
  },
];